import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { getPopularSearches } from '../../actions';
import Router from 'next/router';

export default class AppSearchTrending extends Component {
    constructor(props) {
        super(props);
        this.state = { popularSearches: [] };
        // this.searchForResults = throttle(this.searchForResults, 500);
        // this.props.loadingUserDetailsState(true);
    }

    componentDidMount() {
        // const { queryText } = this.props;
        // const podcasts = await this.setPageData(queryText);
        const { genre } = this.props;
        getPopularSearches(genre || 'All').then((data) => {
            this.setState({ popularSearches: data });
        });
    }

    handleSearch(text) {
        console.log(text);
        const textNew = text.replace(/ /g, '-');
        Router.push(`/search-all?text=${textNew}`, `/search/${textNew}`)
    }

    render() {
        const { popularSearches } = this.state;
        return (
            <div>
                {popularSearches.map((popularSearch, index) => (
                    <div key={index} onClick={this.handleSearch.bind(this, popularSearch.name)} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        <h5 style={{ width: '12px', textAlign: 'right' }}>{index + 1}</h5>
                        <h5 style={{ paddingLeft: '1em' }}>{popularSearch.name}</h5>
                    </div>
                ))}
            </div>
        )
    }
}
AppSearchTrending.propTypes = {
    popularSearches: PropTypes.array,
    genre: PropTypes.string
}
